import React from 'react';
import { LeadForm } from '../../components/LeadForm';
const PROGRAM_OPTIONS = ['Adult Taekwondo', 'Adult Fitness', 'Self-Defense', 'Family Classes', 'General Question'] as const;
export function AdultHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-534">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg text-sm" data-id="element-535">
        Find the Right Adult Class
      </div>
      <div className="mt-4" data-id="element-536">
        <LeadForm buttonText="Check Availability" programOptions={PROGRAM_OPTIONS} defaultProgram="Adult Taekwondo" helperText="A Storm coach will help you pick the right starting class based on your goals and experience." data-id="element-537" />
      </div>
    </div>;
}